<script setup lang="ts">
import InputText from '@/components/input-text.vue'

defineProps<{ name: string, address: (string|null)[], vatNumber: string|null }>()
defineEmits<{ 'update:poNumber': [value: string] }>()

const poNumber = defineModel<string>('poNumber')
</script>

<template>
  <div class="d-flex flex-column">
    <div :class="$style.name">{{ name }}</div>
    <div :class="$style.address">{{ address.filter(x => x !== null && x?.trim() !== '').join(', ') }}</div>
    <div :class="$style['vat-no']">
      <span class="fw-bold">VAT No.</span>
      <span>{{ vatNumber }}</span>
    </div>
    <div :class="$style['po-no']" class="d-flex align-items-center">
      <span>PO No.</span>
      <InputText v-model:value="poNumber" />
    </div>
  </div>
</template>

<style module lang="scss">
.name {
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 15px;
  font-weight: bold;
}

.vat-no {
  display: flex;
  gap: 27px;
  margin-bottom: 10px;
}

.address {
  margin-bottom: 16px;
}

.po-no {
  > span:first-child {
    margin-right: 27px;
  }
}
</style>
